
import React from 'react';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t, i18n } = useTranslation();

  // 根据语言选择 logo 图片
  const logoSrc = i18n.language === 'zh' ? '/images/logo/logon_cn.png' : '/images/logo/uhomes.png';
  const logoAlt = i18n.language === 'zh' ? '异乡好居' : 'uhomes.com';

  return (
    <footer className="bg-white border-t border-slate-200 py-8 sm:py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          {/* Logo */}
          <div className="flex items-center gap-2">
            <img src={logoSrc} alt={logoAlt} className="h-5 sm:h-6 w-auto" />
          </div>

          {/* 法律链接 */}
          <div className="flex gap-6 text-xs sm:text-sm text-slate-600">
            <a
              href={i18n.language === 'zh' ? '/privacy-policy-zh.html' : '/privacy-policy.html'}
              className="hover:text-blue-600 transition-colors cursor-pointer py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded-md"
            >
              {t('footer.privacyPolicy')}
            </a>
            <a
              href={i18n.language === 'zh' ? '/terms-of-use-zh.html' : '/terms-of-use.html'}
              className="hover:text-blue-600 transition-colors cursor-pointer py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded-md"
            >
              {t('footer.termsOfUse')}
            </a>
          </div>

          {/* 版权信息 */}
          <p className="text-xs text-slate-600">
            {t('footer.copyright', { year: new Date().getFullYear() })}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
